class PositionSourceModel extends App.Models.BaseModel {
  modelUrl = null;
  idAttribute = null;

  constructor(attributes) {
    super();
    // Math.random() is used here for generating a temporary client-side ID.
    // This is not used for any security-sensitive purpose.
    // It is used to uniquely identify the model instance in the client-side application.
    // The ID is not persisted to the server.
    this.cid =
      'c_' +
      (
        Date.now().toString(36) + Math.random().toString(36).substring(2, 7)
      ).toUpperCase();
    const coordinates = new App.Collections.Coordinates();
    coordinates.add(attributes.coordinates || []);
    attributes &&
      this.set({
        ...attributes,
        coordinates,
        id: attributes.positionSource.source
      });
  }
}

App.Models.PositionSource = PositionSourceModel;
